module.exports = __webpack_public_path__ + "static/media/Syv.76152931.PNG";